import React from 'react';
import Navbar from './pages/Navbar';
import { Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import Error from './pages/Error'
import './App.css';
import Footer from './pages/Footer';
import NormERROR from './pages/NormERROR';
import HpSearch from './pages/brand/hp/HpSearch';
import HpForm from './pages/brand/hp/HpForm';
import BrSearch from './pages/brand/brother/BrSearch';
import BrForm from './pages/brand/brother/BrForm';
import EpSearch from './pages/brand/epson/EpSearch';
import EpForm from './pages/brand/epson/EpForm';
import CaSearch from './pages/brand/canon/CaSearch';
import CaForm from './pages/brand/canon/CaForm';
import DownPage from './pages/DownPage';

const App = () => {
  return (
    <>
    <Navbar/>
    <Switch>
      <Route exact path ="/" component={DownPage}/>
      {/* <Route exact path ="/" component={Home}/> */}

      <Route exact path ="/:brandtype/driver-error" component={NormERROR}/>

            <Route exact path ="/hp/search" component={HpSearch}/>
      <Route exact path ="/hp/driver-download" component={HpForm}/>

      <Route exact path ="/brother/search" component={BrSearch}/>
      <Route exact path ="/brother/driver-download" component={BrForm}/>

      <Route exact path ="/epson/search" component={EpSearch}/>
      <Route exact path ="/epson/driver-download" component={EpForm}/>

      <Route exact path ="/canon/search" component={CaSearch}/>
      <Route exact path ="/canon/driver-download" component={CaForm}/>

<Route component={Error} />
   
      
     
    </Switch>
    <Footer />
    
     

    </>
  )
}

export default App;